// import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "motion/react";
import Viewer from "viewer/pages/Viewer";

export default function AppRoutes() {
  return (
    <AnimatePresence initial={false} mode="wait">
      <Viewer />
    </AnimatePresence>
  );
}
// export default function AppRoutes() {
//   const location = useLocation();
//   return (
//     <AnimatePresence initial={false} mode="wait">
//       <Routes key={location.pathname} location={location}>
//         <Route path="/viewer" element={<Viewer />} />
//       </Routes>
//     </AnimatePresence>
//   );
// }
